module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "mode": "in-out",
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "loader-wrapper"
  }, [_c('div', {
    staticClass: "loader"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-078bd3dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Loader.vue
// module id = 720
// module chunks = 0